<div *adaptLoading="isLoading">
    @if (data.length) {
        <dx-polar-chart [pathModified]="true"
                        [dataSource]="data"
                        [title]="title"
                        [customizePoint]="culturalIndexUiService.customiseChartPoint"
                        (onInitialized)="onInitialized($event)"
                        (onPointClick)="onPointClick($event)">
            <dxo-polar-chart-common-series-settings type="scatter"> </dxo-polar-chart-common-series-settings>
            <dxo-polar-chart-legend [visible]="false"> </dxo-polar-chart-legend>
            <dxo-polar-chart-tooltip [enabled]="true"
                                     [customizeTooltip]="customiseTooltip"> </dxo-polar-chart-tooltip>
            <dxo-polar-chart-loading-indicator>
                <dxo-polar-chart-font [size]="30"> </dxo-polar-chart-font>
            </dxo-polar-chart-loading-indicator>
            <dxo-polar-chart-argument-axis type="discrete">
                <dxo-polar-chart-label [visible]="false"> </dxo-polar-chart-label>
                <dxo-polar-chart-minor-tick [visible]="false"> </dxo-polar-chart-minor-tick>
                <dxo-polar-chart-tick [visible]="false"> </dxo-polar-chart-tick>
                <dxo-polar-chart-grid [visible]="false"> </dxo-polar-chart-grid>
                <dxo-polar-chart-minor-grid [visible]="false"> </dxo-polar-chart-minor-grid>
            </dxo-polar-chart-argument-axis>
            <dxo-polar-chart-value-axis [maxValueMargin]="0.001"
                                        visualRangeUpdateMode="keep"
                                        [tickInterval]="0.5"
                                        [visualRange]="[0, 2]">
                <dxo-polar-chart-minor-tick [visible]="false"> </dxo-polar-chart-minor-tick>
                <dxo-polar-chart-tick [visible]="false"> </dxo-polar-chart-tick>
                <dxo-polar-chart-minor-grid [visible]="false"> </dxo-polar-chart-minor-grid>
                <dxo-polar-chart-label [visible]="false"> </dxo-polar-chart-label>
            </dxo-polar-chart-value-axis>
            <dxi-polar-chart-series valueField="value"
                                    argumentField="index"
                                    tagField="culturalIndex"> </dxi-polar-chart-series>
            <dxi-polar-chart-series valueField="max"
                                    argumentField="index">
                <dxo-polar-chart-point [visible]="false"> </dxo-polar-chart-point>
            </dxi-polar-chart-series>
            <dxi-polar-chart-series valueField="min"
                                    argumentField="index">
                <dxo-polar-chart-point [visible]="false"> </dxo-polar-chart-point>
            </dxi-polar-chart-series>
            <dxo-polar-chart-margin [bottom]="marginBottom"
                                    [left]="0"> </dxo-polar-chart-margin>
            <dxo-polar-chart-size [height]="height"> </dxo-polar-chart-size>
        </dx-polar-chart>
    }

    @if (!data.length) {
        <div>
            <adapt-no-cultural-measurement label="Cultural Indexes"></adapt-no-cultural-measurement>
        </div>
    }
</div>
